import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HelpIcon from '@mui/icons-material/Help';
import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';

import HelpModal from '../HelpModal';

import { styles } from './index.styles';

export const DASHBOARD_HELP_MODAL_BUTTON_TEST_ID =
  'dashboard-help-modal-button';

export interface ButtonHelpModalProps extends ButtonProps {}

const ButtonHelpModal: FC<ButtonHelpModalProps> = ({ sx = [], ...props }) => {
  const { t } = useTranslation('dashboard');
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        className="ButtonHelpModal-root"
        color="inherit"
        data-test-id={DASHBOARD_HELP_MODAL_BUTTON_TEST_ID}
        endIcon={<HelpIcon color="primary" />}
        onClick={() => setShowModal(true)}
        sx={{ ...styles.buttonHelpModal, ...(Array.isArray(sx) ? sx : [sx]) }}
        variant="text"
        {...props}
      >
        {t('Labels.ImportantInformation')}
      </Button>

      <HelpModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default ButtonHelpModal;
